import React from 'react';
import PropTypes from 'prop-types';
import Literal from 'components/literal';
import { ButtonTertiaryCompact } from 'components/buttons';
import { Filter } from 'components/SvgIcons';
import { CFM_STONE } from 'constants/Colors';
import './styles.scss';

const TableActionsBar = (props) => {
    const {
        dataTest = '',
        onFiltersClick = () => null,
        withFilters,
        showFilters,
        buttonsComponent,
        rowActionsComponent,
    } = props;

    const renderFilterButton = () => {
        const classNames = ['float-right', 'table-actions-bar__btn-filter'];
        if (withFilters) {
            classNames.push('table-actions-bar__btn-filter__with-filters');
        }
        return (
            <ButtonTertiaryCompact
                classNames={classNames}
                onClick={onFiltersClick}
                icon={<Filter withFilters={withFilters} color={CFM_STONE} />}
                dataTest={dataTest}
            >
                <Literal literal="cfm_action_filter" />
            </ButtonTertiaryCompact>
        );
    };

    const renderButtons = () =>
        buttonsComponent && <div className="buttons float-right">{buttonsComponent}</div>;

    const renderRowActionBtns = () =>
        rowActionsComponent && <div className="float-left">{rowActionsComponent}</div>;

    return (
        <div className="table-actions-bar__container">
            {renderRowActionBtns()}
            {!showFilters && renderFilterButton()}
            {renderButtons()}
        </div>
    );
};

TableActionsBar.propTypes = {
    buttonsComponent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    rowActionsComponent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    onFiltersClick: PropTypes.func,
    withFilters: PropTypes.bool,
    showFilters: PropTypes.bool,
    dataTest: PropTypes.string,
};

export default TableActionsBar;
